import React, { Component } from "react";
import firebase, { db, doc } from "./firebase";
import log from "./splunk";
import { Redirect, Switch } from "react-router-dom";
import { PrivateRoute } from "react-router-with-props";
import Content from "./Content";
import FormWrapper from "./FormWrapper";
import Preview from "./Preview";
import _ from "lodash";
import "./bootstrap.scss";
import "./App.scss";
import { focusTitle } from "./aria";

let subsRef = db.collection("submissions");
let completedSubsRef = db.collection("completedSubmissions");
// eslint-disable-next-line
let usersRef = db.collection("users");

const CONTENT_DEFAULTS = {
  confirm:
    "<div><h2>Thank you</h2><p>Your application has been received.</div>",
  late: "<div><p>Your application was submitted after the deadline.</p></div>",
  submitButton: "Submit Application"
};

class App extends Component {
  constructor(props) {
    super(props);
    // console.log("AppProps", props);
    // this.appsRef = appsRef;
    this.state = {
      alerts: [],
      application: props.application || {},
      authStatus: false,
      data: {},
      isSubmitting: false,
      page: 0,
      pageErrors: [],
      subID: null,
      isSubmitted: false,
      submittedData: {}
    };
    // console.log("constructor", props);

    this.subRef = null;
    this.destination = null;

    this.addAlert = this.addAlert.bind(this);
    this.addLog = this.addLog.bind(this);
    this.createSubmission = this.createSubmission.bind(this);
    // this.fetchApplication = this.fetchApplication.bind(this);
    this.fetchSubmission = this.fetchSubmission.bind(this);
    this.getNow = this.getNow.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setDestination = this.setDestination.bind(this);
    this.submitAndNavigate = this.submitAndNavigate.bind(this);
    this.submitSubmission = this.submitSubmission.bind(this);
    this.updateErrors = this.updateErrors.bind(this);
    this.updateSubmission = this.updateSubmission.bind(this);
  }

  componentWillMount() {
    if (
      this.state.subID === null &&
      !_.isUndefined(this.props.appID) &&
      !_.isUndefined(this.props.userID)
    ) {
      // console.log("fetchSubmission");
      this.fetchSubmission(this.props.appID, this.props.userID);
    }
  }

  componentWillReceiveProps(newProps) {
    if (
      this.state.subID === null &&
      !_.isUndefined(newProps.appID) &&
      !_.isUndefined(newProps.userID)
    ) {
      // console.log("fetchSubmission");
      this.fetchSubmission(newProps.appID, newProps.userID);
    }
  }

  getNow() {
    return new Date().toLocaleString();
  }

  addLog(data) {
    let event = {
      data: data,
      appID: this.props.appID,
      slug: this.props.application.slug,
      subID: this.state.subID,
      userID: this.props.userID
    };

    log(event);
  }

  addAlert(type, message) {
    // this.setState({
    //   alerts: this.state.alerts.concat([{ "type": type, "message": message, "id": new Date().getTime() }])
    // });
  }

  fetchSubmission(appID, userID) {
    let subQuery = subsRef
      .where("appID", "==", appID)
      .where("userID", "==", userID);

    this.unsubSubQuery = subQuery.onSnapshot(snapshot => {
      if (snapshot.empty) {
        console.log("No submission found, adding empty submission");
        this.createSubmission(this.props.appID, this.props.userID);
      } else {
        snapshot.forEach(doc => {
          let source = doc.metadata.hasPendingWrites ? "Local" : "Server";
          // console.log(source, doc.id, " => ", doc.data());
          this.subRef = doc.ref;
          let docData = doc.data();

          let proposedState = {
            initialData: docData.data,
            subID: doc.id,
            data: docData.data,
            isSubmitted: docData.isSubmitted
          };

          if ("timeSubmitted" in docData) {
            proposedState.timeSubmitted = doc.data().timeSubmitted;
          }

          this.setState(proposedState);
        });
      }
    });
  }

  createSubmission(appID, userID) {
    subsRef.doc(appID + "-" + userID)
      .set({
        appID: appID,
        userID: userID,
        timeStarted: firebase.firestore.FieldValue.serverTimestamp(),
        isSubmitted: false
      }, {merge: true})
      .then(newRef => {
        console.log("Submission started with ID: ", newRef.id);
        this.subRef = newRef;
        this.setState({
          subID: newRef.id
        });
      })
      .catch(error => {
        this.addLog({ error: error, message: "Error adding submission" });
        // console.error("Error adding submission: ", error);
      });
  }

  updateSubmission(data) {
    // replace undefined entries with empty strings
    // console.log("update submission", data);
    let formData = JSON.parse(
      JSON.stringify(data, (key, value) => {
        return value == null ? "" : value;
      })
    );
    console.log(":: FORMDATA BEFORE POSTING TO FIREBASE", formData)

    this.addLog({
      action: "updateSubmission",
      data: formData
    });

    console.log("sending", formData);
    // update firestore
    this.subRef
      .set(
        {
          data: {...formData, last_update: firebase.firestore.FieldValue.serverTimestamp()},
          timeUpdated: firebase.firestore.FieldValue.serverTimestamp()
        },
        { merge: true }
      )
      .then(() => {
        console.log("submission saved");
      })
      .catch(error => {
        // console.error("Error updating submission: ", error);
        this.addLog({
          error: error,
          message: "Error updating submission",
          data: formData
        });
      });
  }

  submitSubmission() {
    let formData = this.state.data;

    this.setState({
      isSubmitting: true
    });

    this.addLog({
      message: "Submitting",
      data: formData
    });

    // update firestore
    let timestamp = firebase.firestore.FieldValue.serverTimestamp();

    this.subRef
      .update({
        data: formData,
        submittedData: formData,
        timeUpdated: timestamp,
        timeSubmitted: timestamp,
        isSubmitted: true
      })
      .then(() => {
        completedSubsRef
          .doc(this.state.subID)
          .set({
            data: formData,
            submittedData: formData,
            timeSubmitted: timestamp,
            appID: this.props.appID,
            userID: this.props.userID,
            subID: this.state.subID,
            isSubmitted: true
          }, {merge: true})
          .then(() => {
            // console.log("Submission filed with ID: ", this.state.subID);
            this.setState(
              {
                isSubmitted: true,
                isSubmitting: false
              },
              () => {
                this.props.history.push(
                  `/${this.props.application.slug}/confirm`
                );
              }
            );
          })
          .catch(error => {
            // console.error("Error submitting submission: ", error);
            this.setState({
              isSubmitting: false
            });

            this.addLog({
              error: error,
              message: "Error adding completed submission"
            });
          });
      })
      .catch(error => {
        // console.error("Error submitting submission: ", error);
        this.setState({
          isSubmitting: false
        });
        this.addLog({
          error: error,
          message: "Error submitting submission",
          data: formData
        });
      });
  }

  handleSubmit(data, b) {
    // console.log("handleSubmit", data);
    this.updateSubmission(data);
    this.setState({ data: data, initialData: data, saved: true });
  }

  updateErrors(pageID, valid) {
    console.log("updateErrors", pageID, valid);
    let newPageErrors = this.state.pageErrors;
    if (newPageErrors[pageID] !== valid) {
      newPageErrors[pageID] = valid;

      this.setState({
        pageErrors: newPageErrors
      });
    }
  }

  setDestination(newDestination) {
    this.destination = newDestination;
    focusTitle();
  }

  submitAndNavigate(values, b) {
    console.log("submitAndNavigate", values, b);
    this.handleSubmit(values);
    if (this.destination) {
      window.scroll(0, 0);
      this.props.history.push(this.destination);
      this.destination = null;
    }
  }

  render() {
    let {
      application = {},
      authStatus,
      history,
      isApplicationOpen,
      ...props
    } = this.props;

    let {
      appID,
      data,
      initialData,
      isSubmitted,
      isSubmitting,
      pageErrors,
      subID,
      userID,
      timeSubmitted
    } = this.state;

    let slug = application.slug;

    let propFunctions = {
      appID: props.appID,
      application: application,
      authed: authStatus,
      data: data,
      handleSubmit: this.handleSubmit,
      initialValues: initialData,
      isApplicationOpen: isApplicationOpen,
      isSubmitted: isSubmitted,
      isSubmitting: isSubmitting,
      location: props.location,
      logout: () => {
        this.unsubSubQuery();
        props.logout();
      },
      pageErrors: pageErrors,
      setDestination: this.setDestination,
      subID: subID,
      submitAndNavigate: this.submitAndNavigate,
      submitSubmission: this.submitSubmission,
      timeSubmitted: timeSubmitted,
      updateErrors: this.updateErrors,
      user: props.user,
      userID: userID
    };

    let dummy = (a, b, c) => {
      console.log("dummy", a, b, c);
    };

    let content = _.defaults(application.content, CONTENT_DEFAULTS);

    let confirmContent = "";

    if (isSubmitted) {
      if ("dateClose" in application && timeSubmitted > application.dateClose) {
        confirmContent = content.late;
      } else {
        confirmContent = content.confirm;
      }
    }

    return (
      <div className="App h-100">
        <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top d-md-none">
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#primaryNav"
            aria-controls="primaryNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
        </nav>
        {_.isUndefined(application.slug) ? (
          <p>Loading...</p>
        ) : (
          <div className="container h-100">
            {this.props.errorMessage !== "" && (
              <div className="alert alert-info">{this.props.errorMessage}</div>
            )}
            <Switch>
              <PrivateRoute
                path="/:application/form/:page"
                redirectTo="/"
                component={FormWrapper}
                onChange={dummy}
                {...propFunctions}
              />
              <PrivateRoute
                path="/:application/review"
                authed={props.authStatus}
                redirectTo="/"
                component={Preview}
                onChange={dummy}
                {...propFunctions}
              />
              {"welcome" in content ? (
                <PrivateRoute
                  path="/:application/welcome"
                  authed={props.authStatus}
                  redirectTo="/"
                  component={Content}
                  content={content.welcome}
                  link={`/${slug}/form`}
                  {...propFunctions}
                />
              ) : (
                <Redirect
                  exact
                  from="/:application/welcome"
                  to={`/${slug}/form/0`}
                />
              )}
              {"help" in content && (
                <PrivateRoute
                  path="/:application/help"
                  authed={props.authStatus}
                  redirectTo="/"
                  component={Content}
                  content={content.help}
                  {...propFunctions}
                />
              )}
              <PrivateRoute
                path="/:application/confirm"
                authed={props.authStatus}
                redirectTo="/"
                component={Content}
                content={confirmContent}
                {...propFunctions}
              />
              <Redirect
                exact
                from="/:application/form"
                to={`/${slug}/form/0`}
              />
              <Redirect exact from="/:application" to={`/${slug}/welcome`} />
            </Switch>
          </div>
        )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js